// @ts-nocheck
import AdminConstants from "./AdminConstants";
import call from "../../service/http";
import AuthService from "@/modules/auth/AuthService";

export default {
  namespaced: true,
  state: {
    settings: {},
    users: [],
    current_page: 1,
    first_page_url: null,
    next_page_url: null,
    per_page: null,
    prev_page_url: null,
    total: null,
    last_page_url: null,
    last_page: null,
    from: 1,
    to: null,
    links: [],
    abortController: null,
  },
  mutations: {
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },
  getters: {
    adminGetters: (state) => (val) => state[val],
  },
  actions: {
    getSettings: ({ commit }) => {
      call("get", AdminConstants.admin_settings)
        .then((res) => {
          commit("MUTATE", { state: "settings", data: res.data.data });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    addSettings: ({ commit, dispatch }, payload) => {
      commit("SET_LOADING", true, { root: true });
      call("post", AdminConstants.admin_settings, payload)
        .then(() => {
          commit("SET_LOADING", false, { root: true });
          dispatch("getSettings");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("SET_LOADING", false, { root: true });
        });
    },
    checkPrfoileApplication: async ({ commit }, payload) => {
      commit("SET_LOADING", true, { root: true });
      return await call(
        "post",
        AdminConstants.checkProfileApplication,
        payload
      );
    },
    createNewProfileApplication: async ({ commit }, payload) => {
      commit("SET_LOADING", true, { root: true });
      return await call(
        "post",
        AdminConstants.createNewProfileApplication,
        payload
      );
    },
    updateSettings: ({ commit, dispatch }, payload) => {
      commit("SET_LOADING", true, { root: true });
      call("post", AdminConstants.update_settings, payload)
        .then(() => {
          commit("SET_LOADING", false, { root: true });
          dispatch("getSettings");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("SET_LOADING", false, { root: true });
        });
    },
    getUsers: ({ commit, state }, params) => {
      // commit("SET_LOADING", true, { root: true });
      const controller = new AbortController();
      if (state.abortController) {
        controller.abort();
      }
      const signal = controller.signal;
      commit("MUTATE", { state: "abortController", data: signal });
      call(
        "get",
        AdminConstants.user_settings({
          ...(params?.limit && { limit: params?.limit }),
          ...(params?.q && { q: params?.q }),
          ...(params?.page && { page: params?.page }),
        }),
        null,
        {
          signal: signal,
        }
      )
        .then((res) => {
          commit("SET_LOADING", false, { root: true });
          commit("MUTATE", { state: "users", data: res.data.data.data });
          commit("MUTATE", {
            state: "current_page",
            data: res.data.data.current_page,
          });
          commit("MUTATE", {
            state: "first_page_url",
            data: res.data.data.first_page_url,
          });
          commit("MUTATE", {
            state: "next_page_url",
            data: res.data.data.next_page_url,
          });
          commit("MUTATE", { state: "per_page", data: res.data.data.per_page });
          commit("MUTATE", {
            state: "prev_page_url",
            data: res.data.data.prev_page_url,
          });
          commit("MUTATE", { state: "total", data: res.data.data.total });
          commit("MUTATE", {
            state: "last_page_url",
            data: res.data.data.last_page_url,
          });
          commit("MUTATE", { state: "from", data: res.data.data.from });
          commit("MUTATE", {
            state: "last_page",
            data: res.data.data.last_page,
          });
          commit("MUTATE", { state: "to", data: res.data.data.to });
          commit("MUTATE", { state: "links", data: res.data.data.links });
          commit("MUTATE", { state: "abortController", data: null });
        })
        .catch((error) => {
          // commit("SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    updateUser: ({ commit, dispatch }, payload) => {
      commit("SET_LOADING", true, { root: true });
      call("post", AdminConstants.update_user(payload.id), payload)
        .then(() => {
          Event.$emit("close-dialog");
          commit("SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "User updated successfully");
          dispatch("getUsers", { limit: 10 });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("SET_LOADING", false, { root: true });
        });
    },
    deleteUser: ({ commit, dispatch }, payload) => {
      commit("SET_LOADING", true, { root: true });
      call("post", AdminConstants.delete_user(payload.id), payload)
        .then(() => {
          commit("SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "User deleted successfully");
          dispatch("getUsers", { limit: 10 });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("SET_LOADING", false, { root: true });
        });
    },
    sendPasswordReset: ({ commit, dispatch }, payload) => {
      commit("SET_LOADING", true, { root: true });
      call("post", AdminConstants.send_activation_link, payload)
        .then(() => {
          commit("SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Password Reset link sent successfully");
          dispatch("getUsers", { limit: 10 });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("SET_LOADING", false, { root: true });
        });
    },
    loginAs: ({ commit }, payload) => {
      commit("SET_LOADING", true, { root: true });
      call("post", AdminConstants.login_as, payload)
        .then((res) => {
          commit("SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Logged in as user successfully");
          AuthService.loginAs(res.data.data.token, res.data.data.user);
        })
        .catch((error) => {
          console.error(error);
          console.log(error);
          Event.$emit(
            "ApiError",
            error.response?.data?.message ?? error?.message
          );
          commit("SET_LOADING", false, { root: true });
        });
    },
  },
};
